/**
 * Zone JS is required by default for this application.
 */
import 'zone.js';

if (typeof SVGElement.prototype.contains === 'undefined') {
	SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}

(window as any).global = window;
